import { useEffect, useState } from 'react';

import {
  hasInlineImageUploadsInFlight,
  subscribeInlineImageUploadsInFlight,
} from '../utils/richContent/inlineAttachmentName';

/** True while any rich-text field is uploading or staging an inline image. */
export function useInlineImageUploadsInFlight(): boolean {
  const [inFlight, setInFlight] = useState(hasInlineImageUploadsInFlight);
  useEffect(
    () =>
      subscribeInlineImageUploadsInFlight(() => {
        setInFlight(hasInlineImageUploadsInFlight());
      }),
    [],
  );
  return inFlight;
}
